/**
 * Menu Extraction Selectors
 * Redux selectors for menu extraction state
 */

import { RootState } from '../index';

export const selectMenuExtractions = (state: RootState) =>
  state.menuExtractions.extractions;

export const selectCurrentExtraction = (state: RootState) =>
  state.menuExtractions.currentExtraction;

export const selectIsExtracting = (state: RootState) =>
  state.menuExtractions.isExtracting;

export const selectIsCommitting = (state: RootState) =>
  state.menuExtractions.isCommitting;

export const selectExtractionError = (state: RootState) =>
  state.menuExtractions.error;

export const selectPendingExtractions = (state: RootState) =>
  state.menuExtractions.extractions.filter((e) => e.status === 'pending');

export const selectReviewedExtractions = (state: RootState) =>
  state.menuExtractions.extractions.filter((e) => e.status === 'reviewed');

export const selectHasPendingExtraction = (state: RootState) =>
  state.menuExtractions.extractions.some((e) => e.status === 'pending');

export const selectExtractionById = (id: string) => (state: RootState) =>
  state.menuExtractions.extractions.find((e) => e.id === id);

export const selectExtractionOutput = (state: RootState) =>
  state.menuExtractions.currentExtraction?.json_output || null;

export const selectExtractedCategories = (state: RootState) =>
  state.menuExtractions.currentExtraction?.json_output?.categories || [];

export const selectExtractedAddonLibrary = (state: RootState) =>
  state.menuExtractions.currentExtraction?.json_output
    ?.addon_library_discovery || [];

export const selectExtractionStats = (state: RootState) => {
  const output = state.menuExtractions.currentExtraction?.json_output;
  if (!output) {
    return { categories: 0, items: 0, addons: 0 };
  }

  const categories = output.categories.length;
  const items = output.categories.reduce(
    (acc, cat) => acc + cat.items.length,
    0,
  );
  const addons = output.addon_library_discovery.length;

  return { categories, items, addons };
};
